<template>
  <div id="app">
    <section class="hero is-info">
      <div class="hero-body">
        <p class="title has-text-centered">
          GERAKAN PANDAI NEWS
        </p>
      </div>
    </section>
    <div class="container-1056">
      <div class="card" style="background-image: linear-gradient(0deg, #FFFFFF 67.46%, #DDF2FA 100%) ; background-repeat: no-repeat; background-size: cover">
        <div class="card-image">
          <b-carousel :autoplay="false">
            <b-carousel-item  v-if="news.picture !== null">
                <section class="hero is-large">
                    <div class="hero-head has-text-centered">
                      <span class="image is-5by3">
                      <img style="object-position: center; object-fit: contain"  :src="getPicture(news.picture)" >
                      </span>
                    </div>
                </section>
            </b-carousel-item>
            <b-carousel-item  v-if="news.picture1 !== null">
                <section class="hero">
                    <div class="hero-head has-text-centered">
                      <span class="image is-5by3">
                        <img style="object-position: center; object-fit: contain"  :src="getPicture(news.picture1)">
                      </span>
                    </div>
                </section>
            </b-carousel-item> 
            <b-carousel-item v-if="news.picture2 !== null">
                <section class="hero">
                    <div class="hero-head has-text-centered">
                      <span class="image is-5by3">
                      <img style="object-position: center; object-fit: contain"  :src="getPicture(news.picture2)">
                      </span>
                    </div>
                </section>
            </b-carousel-item>     
            <b-carousel-item v-if="news.url !=null">
                <section class="hero">
                    <div class="hero-head has-text-centered">
                      <span class="image is-5by3">
                        <iframe class="has-ratio" width="640" height="360" 
                          :src="news.url" frameborder="0" allowfullscreen></iframe>
                      </span>
                    </div>
                </section>
            </b-carousel-item> 
          </b-carousel>
        </div>
        <div class="card-content">
          <div class="media">
            <div class="media-left">
              <figure class="image is-48x48">
                <img src="../assets/bukuCI.png" alt="Placeholder image">
              </figure>
            </div>
            <div class="media-content">
              <p class="title is-4">{{news.title}}</p>
              <p class="subtitle is-6">
                Uploaded:
                <b-icon
                    icon="timer"
                    size="is-small">
                </b-icon>
                  {{new Date(news.created_at).toLocaleDateString('id-ID',{year:'numeric',month:'long',day:'numeric'}) }}
              </p>
            </div>
          </div>

          <div class="content">
            <div class="div">
              <p v-html="news.news" class="font-18"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <section class="section is-medium" style="padding-top:0.1%;padding-bottom:2%;padding-right:5%;padding-left:5%">
      <div>
        <b-carousel :autoplay="false">
          <b-carousel-item  v-if="news.picture !== null">
              <section class="hero is-large">
                  <div class="hero-head has-text-centered">
                    <span class="image is-5by3">
                    <img style="object-position: center; object-fit: contain"  :src="getPicture(news.picture)" >
                    </span>
                  </div>
              </section>
          </b-carousel-item>
          <b-carousel-item  v-if="news.picture1 !== null">
              <section class="hero">
                  <div class="hero-head has-text-centered">
                    <span class="image is-5by3">
                      <img style="object-position: center; object-fit: contain"  :src="getPicture(news.picture1)">
                    </span>
                  </div>
              </section>
          </b-carousel-item> 
          <b-carousel-item v-if="news.picture2 !== null">
              <section class="hero">
                  <div class="hero-head has-text-centered">
                    <span class="image is-5by3">
                    <img style="object-position: center; object-fit: contain"  :src="getPicture(news.picture2)">
                    </span>
                  </div>
              </section>
          </b-carousel-item>
          
          <b-carousel-item v-if="news.url !=null">
              <section class="hero">
                  <div class="hero-head has-text-centered">
                    <span class="image is-5by3">
                      <iframe class="has-ratio" width="640" height="360" 
                        :src="news.url" frameborder="0" allowfullscreen></iframe>
                    </span>
                  </div>
              </section>
          </b-carousel-item> 
        </b-carousel>
     </div>
    </section>
    <section>
      <div class="container" style="text-align:justify;padding-left:8%;padding-right:8%">
        <h1 class="image animate__animated animate__backInUp has-text-centered" style="color:blue; font-size:20px"><b>{{news.title}}</b></h1>
        <br>
        
        <p v-html="news.news"  style="font-size:17px;"></p>
        <br>
        Uploaded:
        <b-icon
            icon="timer"
            size="is-small">
        </b-icon>
          {{new Date(news.created_at).toLocaleDateString('id-ID',{year:'numeric',month:'long',day:'numeric'}) }}
          <br>
      </div>
      <br>
        
    </section> -->
    <section class="hero is-info">
      <div class="rows">
          <div class="row">
              <div class="column">
                    <b-button  class="button is-info" 
                      tag="router-link"
                      to="/homepage"
                      icon-left="arrow-left-bold">Back to Home</b-button>
              </div>
          </div>
      </div>     
    </section>
  </div>
</template>

<script>

export default {
  data() {
    return {
      carousel:true,
      isLoading: false,
      news:'',
      cariNews:'',
      id_news:'',
      newses:[],
      config: {},
      test: 0,
    }
  },
  methods: {
  getData(id_news)
  {
    this.isLoading=true
    var uri = this.$apiUrl + 'news/' + id_news

    this.$http.get(uri).then(response =>
    {
      this.news = response.data.value
    })
  },
  getPicture(picture){
      var uri = this.$apiUrl + 'news/picture/' + picture
        
      return uri;
    },
    
  },
  computed: {
  },
  mounted()
  {
  if(this.$route.params.id) {           
    this.id_news = this.$route.params.id
    this.getData(this.id_news)  
  }
    console.log(this.search)
  }
}
</script>
